import { CREATE_DEPARTMENT } from './createDepartment';
import { UPDATE_DEPARTMENT } from './updateDepartment';
import { DELETE_DEPARTMENT } from './deleteDepartment';
import { UPSERT_DEPARTMENTS } from './upsertDepartments';

import { GET_DEPARTMENT } from './getDepartament';
import { GET_DEPARTMENTS } from './getDepartaments';
import { GET_DEPARTMENTS_OPTIONS } from './getDepartamentsOptions';

export const bpfDepartmentAPI = {
  fetchDepartment: GET_DEPARTMENT,
  fetchDepartments: GET_DEPARTMENTS,
  fetchDepartmentsOptions: GET_DEPARTMENTS_OPTIONS,

  create: CREATE_DEPARTMENT,
  update: UPDATE_DEPARTMENT,
  delete: DELETE_DEPARTMENT,
  upsert: UPSERT_DEPARTMENTS,
};

export * from './useBPFDepartments';
